import {
  ChartBar,
  CurrencyInr,
  FirstAidKit,
  ListChecks,
  Receipt,
  UsersThree,
} from "@phosphor-icons/react";
import ClientsList from "views/ClientsList/ClientsList";
import DashboardPage from "views/Dashboard/Dashboard.js";
import DoctorsList from "views/DoctorsList/DoctorsList";
import Modalities from "views/Modalities/Modalities";
// import Staffs from "views/Sfatts/Staffs";
// import TicketStatusAdmin from "views/TicketStatusAdmin/TicketStatusAdmin";
import WorkLog from "views/WorkLog/WorkLog";
import PriceListPage from "views/PriceListPage/PriceListPage";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: ChartBar,
    component: DashboardPage,
    layout: "/admin",
  },
  {
    path: "/doctors-list",
    name: "Doctors List",
    icon: FirstAidKit,
    component: DoctorsList,
    layout: "/admin",
  },

  {
    path: "/clients-list",
    name: "Clients List",
    icon: UsersThree,
    component: ClientsList,
    layout: "/admin",
  },
  {
    path: "/generate-bill",
    name: "Generate Bill",
    icon: Receipt,
    component: WorkLog,
    layout: "/admin",
  },
  {
    path: "/modalities",
    name: "Modalities",
    icon: ListChecks,
    component: Modalities,
    layout: "/admin",
  },
  {
    path: "/price-list",
    name: "Price List",
    icon: CurrencyInr,
    component: PriceListPage,
    layout: "/admin",
  },
];

export default dashboardRoutes;
